import { render, staticRenderFns } from "./cuentabancaria-form.vue?vue&type=template&id=2ecb3644&scoped=true"
import script from "./cuentabancaria-form.vue?vue&type=script&lang=js"
export * from "./cuentabancaria-form.vue?vue&type=script&lang=js"
import style0 from "./cuentabancaria-form.vue?vue&type=style&index=0&id=2ecb3644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb3644",
  null
  
)

export default component.exports